import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApplicationState, ApplicationSteps, ApplicationPaymentParameters } from "../../../../models/applications.models";
import { ApplicationsConfig } from "../../../../../services/application-config.service";
import { AuthorizationRequest } from "../../../../../payments/services/payment.service";
import { htmlEscape } from "../../../../../Helpers/UtilityFunctions";
import { ApplicationPayment, Payment, ApplicationCreditAuthorization, AuthorizationResponse } from "../../../../../payments/models/paymentItem.model";
import { ApplicationSectionBaseComponent } from "../../../application-section-base/application-section-base.component";
import { AuthService } from "../../../../../services/auth.service";
import { SystemSetting } from "../../../../../admin/models/system-setting.model";

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss', '../../../application-section-base/application-section-base.component.scss'],
    standalone: false
})
export class PaymentComponent extends ApplicationSectionBaseComponent implements OnInit {

    readonly step: ApplicationSteps = ApplicationSteps.Payment;

    @Input() applicationPaymentParameters: ApplicationPaymentParameters;

    @Output() authorizationRequested: EventEmitter<AuthorizationRequest> = new EventEmitter<AuthorizationRequest>();

    private _config: ApplicationsConfig;

    get authorization(): AuthorizationResponse {
        if (this.form == null) return null;
        let ctrl = this.form.get('creditAuthorization');
        if (ctrl == null) return null;
        return <AuthorizationResponse>ctrl.value;
    }

    set authorization(value: AuthorizationResponse) {
        if (this.form == null) return;
        let ctrl = this.form.get('creditAuthorization');
        if (ctrl == null) return;
        ctrl.setValue(value);
        ctrl.updateValueAndValidity();
    }

    get config(): ApplicationsConfig {
        return this._config;
    }

    @Input() set config(value: ApplicationsConfig) {
        this._config = value;
    }

	@Input() expediteSetting: SystemSetting;

    get fees(): ApplicationPayment[] {
        if (this.form == null) return [];
        let ctrl = this.form.get('payments');
        if (ctrl == null) return [];
        return ctrl.value;
    }

    set fees(value: ApplicationPayment[]) {
        if (this.form == null) return;
        let ctrl = this.form.get('payments');
        if (ctrl == null) return;
        ctrl.setValue(value);
	}

	get allowExpedite(): boolean {
		return this.expediteSetting != null && this.expediteSetting.isActive;
	}
   
    @Input() organizationId: string;
    @Input() organizationName: string;

    @Output() receiptIssued: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output() responseUpdated: EventEmitter<AuthorizationResponse> = new EventEmitter<AuthorizationResponse>();

    @Output() updateApplication: EventEmitter<ApplicationPayment[]> = new EventEmitter<ApplicationPayment[]>();

    constructor(_auth: AuthService) { super(_auth); }

    ngOnInit() {
    }

    paymentAuthorizationRequested(authorization: AuthorizationRequest): void {
        authorization.accountInformation.paymentType = this.form.get('paymentType').value;
        authorization.cancelUrl = `/applications/stratigraphic/input/${this.application.applicationNumber}`;
        authorization.failUrl = `/applications/stratigraphic/input/${this.application.applicationNumber}`;
        authorization.flowUrl = htmlEscape(window.location.href);
        authorization.successUrl = `/applications/stratigraphic/input/${this.application.applicationNumber}`;
        let payments: ApplicationPayment[] = <ApplicationPayment[]>this.form.get('payments').value;
        authorization.paymentInformation.amount = 0;
        payments.forEach(p => {
            authorization.paymentInformation.amount += p.fee;
        });
        this.authorizationRequested.emit(authorization);      
    }

    onReceiptIssued(save: boolean): void {
        this.receiptIssued.emit(save);
    }

    requestSave(evt: ApplicationPayment[]): void {
        this.updateApplication.emit(evt);
    }

    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }

    updateResponse(response: AuthorizationResponse): void {
        this.responseUpdated.emit(response);      
    }
}
